import { render } from "./addModuleStall.vue?vue&type=template&id=16418b45"
import script from "./addModuleStall.vue?vue&type=script&lang=js"
export * from "./addModuleStall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__